import { render, staticRenderFns } from "./DashboardSetting.html?vue&type=template&id=07a634e2&scoped=true&external"
import script from "./DashboardSetting.ts?vue&type=script&lang=ts&external"
export * from "./DashboardSetting.ts?vue&type=script&lang=ts&external"
import style0 from "./DashboardSetting.css?vue&type=style&index=0&id=07a634e2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a634e2",
  null
  
)

export default component.exports